<div style="margin: 1em;">
  <h3 style="margin-bottom: .5em;">WORK ORDERS WITH PARTIALLY COMPLETE WORK</h3>

  <label for="startDate">Start Date: &nbsp;</label>
  <p-datepicker id="startDate" [(ngModel)]="startDate" [showIcon]="true"
    (ngModelChange)="onDateChange()"></p-datepicker>

  <label for="endDate" style="margin-left: 1em;">End Date: &nbsp;</label>
  <p-datepicker id="endDate" [(ngModel)]="endDate" [showIcon]="true" (ngModelChange)="onDateChange()"></p-datepicker>
  @if (isLoading) {
  <span style="margin-left:8px">
    <i class="pi pi-spin pi-spinner" style="font-size: 1.5em"></i>
  </span>
  }
</div>

<p-tabs [(value)]="index" (onChange)="handleChange($event)">
  <p-tablist>
    <p-tab [value]="0">
      Tree Wellness
    </p-tab>

    <p-tab [value]="1">
      Tree Work
    </p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      @for (workOrder of wellnessWOs; track workOrder) {
      <app-invoice-partial-work-row [workOrder]="workOrder"></app-invoice-partial-work-row>
      }
    </p-tabpanel>

    <p-tabpanel [value]="1">
      @for (workOrder of workWOs; track workOrder) {
      <app-invoice-partial-work-row [workOrder]="workOrder"></app-invoice-partial-work-row>
      }
      
    </p-tabpanel>

  </p-tabpanels>
</p-tabs>